import React, { useState, useEffect } from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css'

import { ApiService } from '../../../Components/Services/apiServices';
import { Link } from 'react-router-dom';

const BannerSection = () => {
    const [banners, setBanners] = useState([]);
    const [loading, setLoading] = useState(true); 

    useEffect(() => {
        const fetchBanners = async () => {
            try {
                const bannerData = await ApiService.Commanfetchrequest('banners');
                setBanners(bannerData);
                // console.log('Fetched Banners:', bannerData);
            } catch (error) {
                console.error('Error fetching banners:', error);
            } finally {
                setLoading(false); 
            }
        };
        fetchBanners();
    }, []);

    return (
        <section id="hero" className="hero section">
            <div className="hero-bg">
                <img src="http://127.0.0.1:8000/front/images/hero-bg-light.webp" alt="" />
            </div>
            <div className="container">
                <div className="row align-items-center text-center text-lg-start">
                   
                    <div className="col-lg-6 d-flex flex-column justify-content-center">
                        {loading ? (
                            <>
                                <Skeleton count={1} height={130} width="80%" style={{ marginBottom: 10 }} />
                                <Skeleton count={1} height={80} width="80%" style={{ marginBottom: 10 }} />
                                <div className="d-flex justify-content-center justify-content-lg-start">
                                    <Skeleton count={1} height={40} width={200} />
                                    <Skeleton count={1} height={40} width={200} style={{ marginLeft: 10 }} />
                                </div>
                            </>
                        ) : (
                            <>
                                {banners?.length > 0 && banners[0]?.title ? (
                                    <h1>{banners[0]?.title} <span>All-in-One HR Software</span></h1>
                                ) : (
                                   ""
                                )}

                                
                                {banners?.length > 0 && banners[0]?.description ? (
                                    <p dangerouslySetInnerHTML={{ __html: banners[0]?.description }} />
                                ) : (
                                    ""
                                )}
                                <div class="d-flex justify-content-center justify-content-lg-start">
                                    <Link to="/start-free-trial" class="btn-get-started">Start 7-day Free Trial</Link>
                                    <Link to="/book-demo" class="btn-get-started  btn-watch-video d-flex align-items-center">
                                        <span>Book a Demo</span>
                                    </Link>
                                </div>
                            </>
                        )}


                    </div>
                    
                    <div className="col-lg-6">
                        {loading ? (
                            
                            <Skeleton height={500} width="100%" />
                        ) : banners?.length > 0 ? (
                            <img
                                src={`https://sigohrmlpadmin.loopring.in/front/images/banners/${banners[0]?.image}`}
                                className="img-fluid hero-img aos-init aos-animate"
                                alt={banners[0]?.alt || 'Hero image'}
                                data-aos="zoom-out"
                                data-aos-delay={300}
                                style={{ marginTop: 30 }}
                            />
                        ) : (
                            
                            <div className="no-banners">
                                <p>No banners available at the moment. Please check back later.</p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default BannerSection;
